module.exports = __webpack_public_path__ + "static/media/16.82e67020.jpg";